import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { PromiseResult, toPromise } from './toPromise';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PromiseClient {
  private readonly http = inject(HttpClient);

  get<T = any>(url: string, options?: any): PromiseResult<T> {
    return toPromise(this.http.get<T>(url, options) as Observable<T>);
  }

  post<T = any>(
    url: string,
    body: any | null,
    options?: any,
  ): PromiseResult<T> {
    return toPromise(this.http.post<T>(url, body, options) as Observable<T>);
  }

  put<T = any>(url: string, body: any | null, options?: any): PromiseResult<T> {
    return toPromise(this.http.put<T>(url, body, options) as Observable<T>);
  }

  delete<T = any>(url: string, options?: any): PromiseResult<T> {
    return toPromise(this.http.delete<T>(url, options) as Observable<T>);
  }

  patch<T = any>(
    url: string,
    body: any | null,
    options?: any,
  ): PromiseResult<T> {
    return toPromise(this.http.patch<T>(url, body, options) as Observable<T>);
  }
}
